// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1JapQ","col":"styles_col__eBQCo","actions":"styles_actions__2g5mW","conflict":"styles_conflict__3cGT2"};